import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";
import { UpdateProviderRequestStruct } from "../types/UpdateProviderRequest";

export const updateProviderDefinition = getFirebaseFunctionDefinition({
  path: "/providers/update",
  reqType: UpdateProviderRequestStruct,
});
